(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wishlist"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var KEY = 'velmoraWishlist';
  var tbody  = document.getElementById('wishlist-tbody');
  var hasEl  = document.getElementById('wishlist-has-items');
  var emptyEl= document.getElementById('wishlist-empty');
  var loadEl = document.getElementById('wishlist-loading');

  function getItems() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch(e) { return []; }
  }
  function saveItems(items) {
    localStorage.setItem(KEY, JSON.stringify(items));
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function render() {
    var items = getItems();
    loadEl.style.display = 'none';

    if (!items.length) {
      hasEl.style.display  = 'none';
      emptyEl.style.display = 'block';
      return;
    }

    hasEl.style.display  = 'block';
    emptyEl.style.display = 'none';

    tbody.innerHTML = items.map(function(item, i) {
      var priceHtml = item.comparePrice && item.comparePrice > item.price
        ? '<del style="color:var(--text-light);font-weight:400;font-size:13px;">' + formatMoney(item.comparePrice) + '</del> ' + formatMoney(item.price)
        : formatMoney(item.price);

      var stockHtml = item.available !== false
        ? '<span class="wl-stock-status">In Stock</span>'
        : '<span style="color:var(--accent-red);font-size:13px;font-weight:500;">Out of Stock</span>';

      var actionHtml = item.available !== false
        ? '<button class="btn btn-primary wl-add-cart" data-index="' + i + '" data-variant-id="' + item.variantId + '">Add to Cart</button>'
        : '<a href="' + item.url + '" class="btn btn-primary" style="background:var(--text-light);border-color:var(--text-light);">View Product</a>';

      return '<tr>' +
        '<td class="wl-remove"><button class="wl-remove-btn" data-index="' + i + '" title="Remove">×</button></td>' +
        '<td><div class="wl-product">' +
          '<a href="' + item.url + '"><img src="' + item.image + '" alt="' + item.title + '" /></a>' +
          '<div class="wl-product-info"><h5><a href="' + item.url + '">' + item.title + '</a></h5>' +
          (item.sku ? '<span>SKU: ' + item.sku + '</span>' : '') +
          '</div></div></td>' +
        '<td class="wl-price">' + priceHtml + '</td>' +
        '<td>' + stockHtml + '</td>' +
        '<td class="wl-action">' + actionHtml + '</td>' +
      '</tr>';
    }).join('');

    // Remove buttons
    tbody.querySelectorAll('.wl-remove-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var items = getItems();
        items.splice(parseInt(this.dataset.index), 1);
        saveItems(items);
        // Update wishlist badge in header
        var badge = document.querySelector('.wishlist-count-badge');
        if (badge) badge.textContent = items.length;
        render();
      });
    });

    // Add to cart buttons
    tbody.querySelectorAll('.wl-add-cart').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var variantId = parseInt(this.dataset.variantId);
        if (!variantId) return;
        var b = this;
        b.textContent = 'Adding…';
        b.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        }).then(function() {
          b.textContent = 'Added!';
          setTimeout(function() { b.textContent = 'Add to Cart'; b.disabled = false; }, 1500);
          // Refresh cart count
          fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
            document.querySelectorAll('.cart-count-badge').forEach(function(el){ el.textContent = cart.item_count; });
          });
        }).catch(function() { b.textContent = 'Add to Cart'; b.disabled = false; });
      });
    });
  }

  // Add All to Cart
  var addAllBtn = document.getElementById('add-all-to-cart');
  if (addAllBtn) {
    addAllBtn.addEventListener('click', function() {
      var items = getItems().filter(function(it) { return it.available !== false && it.variantId; });
      if (!items.length) return;
      addAllBtn.textContent = 'Adding…';
      addAllBtn.disabled = true;
      var promises = items.map(function(item) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.variantId, quantity: 1 })
        });
      });
      Promise.all(promises).then(function() {
        return fetch('/cart.js').then(function(r){ return r.json(); });
      }).then(function(cart) {
        document.querySelectorAll('.cart-count-badge').forEach(function(el){ el.textContent = cart.item_count; });
        addAllBtn.textContent = 'Added to Cart!';
        setTimeout(function() { addAllBtn.textContent = 'Add All to Cart'; addAllBtn.disabled = false; }, 2000);
      });
    });
  }

  render();
});

  } catch(e) { console.error(e); }
})();
})();
